module.exports = __webpack_public_path__ + "img/transporter-4.7e955674.png";